import { Component, EventEmitter, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BaseAlertComponent } from '../base-alert.component';
import { map } from 'rxjs/operators';
import { AlertBackgroundColorEnum } from '../../../../../../models/alerts/enum/alert-background-color.enum';

@Component({
  selector: 'app-banner-alert',
  templateUrl: './banner-alert.component.html',
  styleUrls: ['./banner-alert.component.scss'],
  standalone: true,
  imports: [CommonModule]
})
export class BannerAlertComponent extends BaseAlertComponent {
  @Output() dismissClicked = new EventEmitter<void>();
  @Output() learnMoreClicked = new EventEmitter<void>();

  setupBindings(): void {}

  setupViews(): void {}

  public isDismissable$ = this.alert$.pipe(map(a => a?.dismissable));

  public dismissButtonSrc$ = this.alert$.pipe(
    map(a => {
      switch (a?.colourId) {
        case AlertBackgroundColorEnum.BannerPurple:
          return 'assets/icons/alerts/PurpleClose.svg';
        case AlertBackgroundColorEnum.BannerBlue:
          return 'assets/icons/alerts/BlueClose.svg';
        case AlertBackgroundColorEnum.BannerGreen:
          return 'assets/icons/alerts/GreenClose.svg';
        case AlertBackgroundColorEnum.BannerYellow:
          return 'assets/icons/alerts/YellowClose.svg';
      }
    })
  );
}
